import { useKeycloak } from '@react-keycloak/web';
import React from 'react';
import {Modal} from 'react-bootstrap';
import '../styles/css/NavigationBar.css';
import { useHistory } from 'react-router-dom';
import logout_icon from '../assets/img/log-out.png';
import user_icon from '../assets/img/user-top-nav.png';
import change_password from '../assets/img/change-password.png';
import ChangePasswordForm from './user/ChangePasswordForm';

const NavigationBar = () => {

  const { keycloak } = useKeycloak();
  let history = useHistory();

  const [modalShow, setModalShow] = React.useState(false);

  const getUSerInfo = () => {
        let user = JSON.parse(localStorage.getItem('user'))
        let fullName = "";
        if(user) {
            fullName = (user.name || "") + " " + (user.surname || "");
        }
        return fullName;
    }


  const logout = () => {
    keycloak.logout().then(() => {
      localStorage.removeItem('user');
      history.push('/');
    });
  };


  return(
        <div className="topnav" id="myTopnav">
            <div className="dropdown-navbar">
                <button className="dropbtn">
                    <img src={user_icon} alt="user" style={{width: "23px", height:"23px", marginRight: "7px", marginBottom: "3px"}}/>
                    {getUSerInfo()}
                </button>
                <div className="dropdown-content-navbar">
                    {/* <li onClick={() => setModalShow(true)}>*/}
                    {/*    <img src={change_password} alt="password" style={{marginRight: "7px", marginBottom:"3px", width: "16px", height: "16px"}}/>*/}
                    {/*    Change Password</li> */}
                    <li onClick={() => logout()}>
                        <img src={logout_icon} alt="logout" style={{marginRight: "7px", marginBottom:"3px", width: "16px", height: "16px"}}/>
                        Logout</li>
                </div>
            </div>
            <ChangePasswordModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </div>
    );

}

function ChangePasswordModal(props) {
    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
                <span id="connection-form-panel-title">Change Password</span>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <ChangePasswordForm />
        </Modal.Body>
      </Modal>
    );
}

export default NavigationBar;
